export default __webpack_public_path__ + "static/KV_AD_9578_rgb-40aeab61ba1af9d48d935ab6432efb3b.jpg";